import styled from "styled-components";
import { propOr } from "ramda";
import { numericFontStyles } from "_/style";

import { Icon } from "_/components/icon";
import { Tooltip as _Tooltip } from "_/components/tooltip";

import { MachineHeatingState } from "./types";

export const Wrapper = styled.div`
  container: machine-temperature / inline-size;
  display: flex;
  min-width: 0;
  background-color: ${(p) => p.theme.background.secondary};
  border-radius: 8px;
  padding: 1.25rem;
  overflow-x: auto;
`;

// Size queries apply to descendants, so `Content` owns the responsive layout.
export const Content = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  @container machine-temperature (width < 42rem) {
    flex-direction: column;
    align-items: flex-start;
    gap: 0;
  }
`;

export const TemperatureRatioDisplay = styled.span`
  display: flex;
  gap: calc(min(6cqw - 2.25rem, 1rem));
  font-size: 1.25rem;
  align-items: center;

  @container machine-temperature (width < 42rem) {
    gap: calc(min(8cqw - 1.25rem, 1rem));
  }

  /* Temps shouldn't jump around when numbers change. */
  ${numericFontStyles}
`;

export const CurrentTemperature = styled.span<{
  $state: MachineHeatingState;
}>`
  color: ${(p) =>
    propOr("inherit", p.$state, {
      heating: p.theme.color.palette.tomatoRed,
      cooling: p.theme.color.palette.electricBlue,
      atTarget: p.theme.color.palette.kellyGreen,
    })};
`;

export const TemperatureDisplayBlock = styled.div`
  display: flex;
  flex-direction: column;
  @container machine-temperature (width < 42rem) {
    flex-direction: row;
    gap: calc(16cqw - 4rem);
  }
`;

export const Title = styled.span`
  font-size: 0.75rem;
  color: ${(p) => p.theme.text.muted};
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  @container machine-temperature (width < 42rem) {
    margin-bottom: 0;
    min-width: 10rem;
  }
`;

export const TooltipIcon = styled(Icon)<{
  $kind: "heating" | "cooling" | "atTarget" | "info";
}>`
  font-size: 1.25rem;
  color: ${(p) =>
    ({
      heating: p.theme.color.palette.tomatoRed,
      cooling: p.theme.color.palette.electricBlue,
      atTarget: p.theme.color.palette.kellyGreen,
      info: p.theme.text.muted,
    })[p.$kind]};
`;

export const Tooltip = styled(_Tooltip)`
  display: inline;
`;
